module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/operator-info.c1ef1241.svg";